import renderAutoSuggestWithOptions from 'app/employer/components/autoSuggest/AutoSuggestHOC';
import { CarrierAutoCompleteInput$, CarrierAutoCompleteObservable$ } from 'app/employer/redux/autosuggest/autoCompleteService';

const CarrierAutoSuggest = renderAutoSuggestWithOptions(
   CarrierAutoCompleteObservable$,
   CarrierAutoCompleteInput$,
);

CarrierAutoSuggest.defaultProps = {
   selected: {
      id: null,
      name: '',
   },
   forceSelection: false,
   placeholder: 'Search Carrier...',
};

export default CarrierAutoSuggest;
